// extracted by mini-css-extract-plugin
export default {"InfoTable":"Sl85FTimsMA7ocJeHRr0","Select":"l4b8pZqmFUqVQZ4FpZla","Pdf":"rvDgMe9V4KvHw2bbfUxw","StudyRedirect":"RJbnguI_UwgnYJ4UfE1e","Description":"ITCWRVYz9OiXyW1khZfQ"};